import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { OfficeDTO } from '@iota/iota-management-portal-v4-client';
import { Store } from '@ngrx/store';
import { map, Observable, take } from 'rxjs';
import { ReloadOffice } from 'src/app/store/actions/office.actions';
import { officeById } from 'src/app/store/reducer/office.reducer';
import { parseMainAddress } from '../../utils';

@Component({
    standalone: false,
    selector: 'app-office-card',
    templateUrl: './office-card.component.html',
    styleUrls: ['./office-card.component.scss']
})
export class OfficeCardComponent implements OnInit {
    @Input() officeId: string;
    @Input() displayAdditionalInfo = false;

    @Output() cardClicked = new EventEmitter<void>();

    office$: Observable<OfficeDTO>;
    address$: Observable<string>;
    naceCodeDescription$: Observable<string>;

    constructor(private store: Store) {}

    ngOnInit(): void {
        if (this.officeId) {
            this.store
                .select(officeById(this.officeId))
                .pipe(take(1))
                .subscribe((company) => {
                    if (!company) {
                        this.store.dispatch(ReloadOffice({ officeId: this.officeId }));
                    }
                });

            this.office$ = this.store.select(officeById(this.officeId));
            this.address$ = this.office$.pipe(map((o) => parseMainAddress(o?.addresses)));
        }
    }
}
